$(document).ready(function(){

    $('.password-btn').addClass('show');

    var accessCheck;
	if ($.cookie('passwordProtect') == null) {
		accessCheck = true;
	}
    if (accessCheck && $('.page-width').hasClass('password-protected') || accessCheck && $('.password-protected').length > 0) {
        //reset variable so cookie is set once and left alone
        accessCheck = true

        if ($('.product-top').length > 0) {
            $('.product-top').removeClass('content-visible').addClass('content-hidden');
        }
        if ($('#products-collection').length > 0) {
            $('#products-collection').removeClass('content-visible').addClass('content-hidden');
        }
        if ($('.details-second').length > 0) {
            $('.details-second').removeClass('content-visible').addClass('content-hidden');
        }

        $('.password-form').show();
        setTimeout(function() {
            $('.password-form .password-input').focus();
        },500);
        
        $('.password-form .password-input').keypress(function(e){
            inputCode = $('.password-input').val().trim().toLowerCase();
            if (inputCode.length > 0) {
            if(e.keyCode==13)
                $('.password-btn.show').click();
            }
        });

        $('.password-btn.show').click(function() {
            inputCode = $('.password-input').val().trim().toLowerCase();
            ourCode = $('.pwp').data('pw').toLowerCase();
            $(this).blur();
            $('.val').hide();
            
            if (inputCode.length > 0) {
                if(ourCode === inputCode) {
                    $('.password-form').hide();
                    $('.password-protected').removeClass('content-hidden').addClass('content-visible');

                    $('.product-top').removeClass('content-hidden').addClass('content-visible');
                    $('#products-collection').removeClass('content-hidden').addClass('content-visible');
                    $('.details-second').removeClass('content-hidden').addClass('content-visible');

                    //set cookie after success
                    $.cookie('passwordProtect', 'yes', { expires: 1, path: '/' });
                    console.log(accessCheck);
                } else {
                    $('.val').text("Sorry, that's not the password we're looking for – please note the password is case sensitive!").slideDown();
                }
            } else {
                $('.val').text("Please enter a password above").slideDown();
            }
        });
    } else {
        $('.password-form').hide();

        if ($('.password-protected').length > 0) {
            $('.password-protected').removeClass('content-hidden').addClass('content-visible');
        }
        if ($('.product-top').length > 0) {
            $('.product-top').removeClass('content-hidden').addClass('content-visible');
        }
        if ($('#products-collection').length > 0) {
            $('#products-collection').removeClass('content-hidden').addClass('content-visible');
        }
        if ($('.details-second').length > 0) {
            $('.details-second').removeClass('content-hidden').addClass('content-visible');
        }
    }

    //FILTERS
    $('.shop-by-size .parent').click(function() {
        if ($(this).parents('li').siblings('li').find('input').is(':checked')) {
            $(this).parents('li').siblings('li').find('input').prop('checked', false);
        }
    });

    $('.facets-container details').click(function() {
        // console.log('clicked');
        // $(this).siblings('details').css('background','red');
        // if ($(this).siblings('details').hasAttribute('open')) {
        //     $(this).siblings('details').removeAttr('open');
        // }

        var details = [...document.querySelectorAll('.facets-container details')];
        document.addEventListener('click', function(e) {
        if (!details.some(f => f.contains(e.target))) {
            details.forEach(f => f.removeAttribute('open'));
        } else {
            details.forEach(f => !f.contains(e.target) ? f.removeAttribute('open') : '');
        }
        })
    });
});//END READY